// Keeps the standalone landing-page CSS from bleeding into the shared site header/footer.
export const LP_CHROME_CSS = `
.lp-chrome{font-family:var(--font-sans);line-height:1.5}
.lp-chrome a{color:inherit}
.lp-chrome h1,.lp-chrome h2,.lp-chrome h3,.lp-chrome h4{color:inherit;font-family:inherit;letter-spacing:normal}
.lp-chrome img{max-width:100%}
.lp-chrome .block{padding:.5rem .75rem}
.lp-chrome nav .absolute .block{padding:.5rem 1rem}
.lp-chrome nav .absolute .border-b.block{padding:.625rem 1rem}
`;
